<template>
<div id="footer">
  <div class="py-4">
  </div>
  <b-container class="py-5">
    <div class="d-flex justify-content-center mb-5">
      <div class="border-top border-bottom border-dark border-2px py-3">
        <h3 class="text-center h1 mb-0">購入はこちらから</h3>
      </div>
    </div>
    <b-row>
      <b-col cols="12" md="6" class="mb-5">
        <div :class="isMobile().phone? 'form-row': 'row'">
          <b-col cols="6" md="5">
            <img class="img-fluid" src="@/assets/images/lineup-1.jpg">
          </b-col>
          <b-col cols="6" md="7" class="d-flex align-items-center">
            <div>
              <h5 class="h4 tracking-1 line-height-1_8">左ききのシャツ<br>ホワイト</h5>
              <p class="mt-3 mt-md-2 mt-lg-4 mb-0">
                <span class="overpass h4 align-middle mr-3">¥12,000</span>
                <b-button variant="primary" class="mt-3 mt-lg-0" pill href="https://hidari-kiki.jp/tags/128/tools/215/" target="_blank">購入ページへ</b-button>
              </p>
            </div>
          </b-col>
        </div>
      </b-col>
      <b-col cols="12" md="6" class="mb-5">
        <div :class="isMobile().phone? 'form-row': 'row'">
          <b-col cols="6" md="5">
            <img class="img-fluid" src="@/assets/images/lineup-2.jpg">
          </b-col>
          <b-col cols="6" md="7" class="d-flex align-items-center">
            <div>
              <h5 class="h4 tracking-1 line-height-1_8">左ききのシャツ<br>ネイビー</h5>
              <p class="mt-3 mt-md-2 mt-lg-4 mb-0">
                <span class="overpass h4 align-middle mr-3">¥12,000</span>
                <b-button variant="primary" pill class="mt-3 mt-lg-0" href="https://hidari-kiki.jp/tags/128/tools/631/" target="_blank">購入ページへ</b-button>
              </p>
            </div>
          </b-col>
        </div>
      </b-col>
      <b-col cols="12" md="6" class="mb-5">
        <div :class="isMobile().phone? 'form-row': 'row'">
          <b-col cols="6" md="5">
            <img class="img-fluid" src="@/assets/images/lineup-3.jpg">
          </b-col>
          <b-col cols="6" md="7" class="d-flex align-items-center">
            <div>
              <h5 class="h4 tracking-1 line-height-1_8">左ききのシャツ<br>ホワイト<br class="d-md-none"><small>(刺繍なし)</small></h5>
              <p class="mt-lg-4 mb-0">
                <span class="overpass h4 align-middle mr-3">¥11,500</span>
                <b-button variant="primary" pill class="mt-3 mt-lg-0" href="https://hidari-kiki.jp/tags/128/tools/852/" target="_blank">購入ページへ</b-button>
              </p>
            </div>
          </b-col>
        </div>
      </b-col>
      <b-col cols="12" md="6" class="mb-5">
        <div :class="isMobile().phone? 'form-row': 'row'">
          <b-col cols="6" md="5">
            <img class="img-fluid" src="@/assets/images/lineup-4.jpg">
          </b-col>
          <b-col cols="6" md="7" class="d-flex align-items-center">
            <div>
              <h5 class="h4 tracking-1 line-height-1_8">左ききのシャツ<br>ネイビー<br class="d-md-none"><small>(刺繍なし)</small></h5>
              <p class="mt-lg-4 mb-0">
                <span class="overpass h4 align-middle mr-3">¥11,500</span>
                <b-button variant="primary" pill class="mt-3 mt-lg-0" href="https://hidari-kiki.jp/categories/2/tools/862/" target="_blank">購入ページへ</b-button>
              </p>
            </div>
          </b-col>
        </div>
      </b-col>
    </b-row>
    <div class="text-center mt-5">
      <b-button variant="link" v-scroll-to="'#feature'" class="btn-scrolltop">
        <img src="@/assets/images/kuma1.png" srcset="@/assets/images/kuma1@2x.png 2x">
        <p class="pr-4 mt-3">さいしょにもどる</p>
      </b-button>
      <br>
      <b-button href="https://hidari-kiki.jp/" target="_blank" variant="light">
        <img src="@/assets/images/logo-shop.png" srcset="@/assets/images/logo-shop@2x.png 2x" alt="左ききの道具店">
      </b-button>
    </div>
  </b-container>
</div>
</template>

<script>
import isMobile from 'ismobilejs'

export default {
  name: 'Footer',
  data() {
    return {
      isMobile: isMobile
    }
  }
}
</script>

<style scoped lang="scss">
.btn-scrolltop {
  color: #333;
  >img {
    display: inline-block;
    transition: transform 0.3s;
    transform: rotate(0deg);
    transform-origin: left bottom;
  }
  &:hover, &:focus {
    text-decoration: none;
    outline: none;
    box-shadow: none;
    >img {
      transform: rotate(-3deg);
    }
  }
}
</style>
